// extracted by mini-css-extract-plugin
var _1 = "MessageBoxStyle-module__message-box___MpLWE";
var _2 = "MessageBoxStyle-module__message-box___MpLWE";
export { _1 as "message-box", _2 as "messageBox" }
